import { DebugEvent } from 'core/DebugEvent';
import { HeaderType } from 'app/views/project/project.types';

interface QueProjectEventInterface {
	slug: string;
	index: number;
	headerType?: HeaderType;
	topUITheme?: string;
}

export class QueProjectEvent extends DebugEvent implements QueProjectEventInterface {
	public static eventName: string = 'QUE_PROJECT_EVENT';
	public slug: string;
	public index: number;
	public headerType: HeaderType;
	public topUITheme: string;

	constructor(parameters: QueProjectEventInterface) {
		super(parameters);
	}
}
